import { defaultAgent, apiResponse } from '../helpers/web-agent';
import * as actionTypes from '../constants/action-types';
import { toastInfo, toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { EQUIPMENT_CREATED, EQUIPMENT_EDITED, EQUIPMENT_DELETED } from '../constants/messages';
import { getSearchDateRange } from '../helpers/common';

export const equipmentListRequest = () => {
    return { type: actionTypes.GET_EQUIPMENT_LIST_REQUEST };
}

export const clearEquipmentFields = () => {
    return { type: actionTypes.CLEAR_EQUIPMENT_FIELDS };
}

export const equipmentConfig = (data = null) => {
    return { type: actionTypes.GET_EQUIPMENT_CONFIG, payload: data };
}

export const getCategoryTypeList = (equipmentTypeId, planTypeId = 0) => {
    return { type: actionTypes.GET_CATEGORY_TYPE_LIST, equipmentTypeId, planTypeId };
}

export const getSubCategoryTypeList = (equipmentTypeId, categoryId) => {
    return { type: actionTypes.GET_SUB_CATEGORY_TYPE_LIST, equipmentTypeId, categoryId };
}

export const getEquipmentFields = (params) => {
    return { type: actionTypes.GET_EQUIPMENT_FIELDS, ...params };
}

export const equipmentNameList = (equipmentType, data = []) => {
    return { type: actionTypes.GET_EQUIPMENT_NAME_LIST, equipmentType, payload: data };
}

export const deviceList = (deviceType, data = []) => {
    return { type: actionTypes.GET_DEVICE_LIST, deviceType, payload: data };
}

export const equipmentList = (data) => {
    return { type: actionTypes.GET_EQUIPMENT_LIST, payload: data };
}

export const equipmentMakeList = (data) => {
    return { type: actionTypes.GET_EQUIPMENT_MAKE_LIST, payload: data };
}

export const equipmentModelList = (data) => {
    return { type: actionTypes.GET_EQUIPMENT_MODEL_LIST, payload: data };
}

export const equipmentVendorList = (data) => {
    return { type: actionTypes.GET_EQUIPMENT_VENDOR_LIST, payload: data };
}

export const equipmentInfo = (data) => {
    return { type: actionTypes.GET_EQUIPMENT_INFO, payload: data };
}

export const clearEquipmentList = () => ({ type: actionTypes.CLEAR_EQUIPMENT_LIST });

export const getEquipmentConfig = (cb = null) => {
    return dispatch => {
        dispatch(clearEquipmentFields());
        defaultAgent.get('/api/equipment/config', { __version: 1 })
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.data) {
                    dispatch(equipmentConfig(agentResult.data));
                    if (cb) cb();
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(equipmentConfig());
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(equipmentConfig());
            });
    }
}

export const createEquipment = (data, cb) => {
    return dispatch => {
        defaultAgent.post('/api/equipment/add', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === EQUIPMENT_CREATED.code) {
                    dispatch(toastSuccess(agentResult.message));
                    if (cb) cb();
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const editEquipment = (data, cb) => {
    return dispatch => {
        defaultAgent.put('/api/equipment/edit', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === EQUIPMENT_EDITED.code) {
                    dispatch(toastSuccess(agentResult.message));
                    if (cb) cb();
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const getEquipmentNameList = ({ farmId, equipmentType, equipmentGroupId }) => {
    return dispatch => {
        const params = {
            farm_uuid: farmId, equipment_type: equipmentType,
            equipment_group_uuid: equipmentGroupId
        };

        defaultAgent.get('/api/equipment/name/list', params)
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(equipmentNameList(equipmentType));
                } else if (agentResult.data) {
                    dispatch(equipmentNameList(equipmentType, agentResult.data));
                }
            })
            .catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(equipmentNameList(equipmentType));
            });
    }
}

export const getDeviceList = ({ farmId, deviceType, includeDeviceId }) => dispatch => {
    defaultAgent.get('/api/device/unassociate/list',
        { farm_uuid: farmId, device_type: deviceType, include_device_uuid: includeDeviceId, __version: 1 })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.data) {
                dispatch(deviceList(deviceType, agentResult.data));
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(deviceList(deviceType));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(deviceList(deviceType));
        });
}

export const getEquipmentList = (params) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to
    };

    dispatch(equipmentListRequest());
    defaultAgent.get('/api/equipment/v1/list', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.data) {
                dispatch(equipmentList(agentResult.data));
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(equipmentList());
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(equipmentList());
        });
}

export const getEquipmentMakeList = () => {
    return dispatch => {
        defaultAgent.get('/api/equipment/make/list').then(res => {
            let makeResult = apiResponse(res, []);
            if (makeResult.isUnauthorized) {
                dispatch(toastError(makeResult.message));
                dispatch(tokenExpired());
            } else if (makeResult.data) {
                dispatch(equipmentMakeList(makeResult.data));
            } else if (makeResult.message) {
                dispatch(toastError(makeResult.message));
                dispatch(equipmentMakeList(null));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(equipmentMakeList(null));
        });
    }
}

export const getEquipmentModelList = (makeId) => {
    return dispatch => {
        defaultAgent.get('/api/equipment/model/list', { equipment_make_id: makeId }).then(res => {
            let modelResult = apiResponse(res, []);
            if (modelResult.isUnauthorized) {
                dispatch(toastError(modelResult.message));
                dispatch(tokenExpired());
            } else if (modelResult.data) {
                dispatch(equipmentModelList(modelResult.data));
            } else if (modelResult.message) {
                dispatch(toastError(modelResult.message));
                dispatch(equipmentModelList(null));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(equipmentModelList(null));
        });
    }
}

export const getEquipmentVendorList = () => {
    return dispatch => {
        defaultAgent.get('/api/equipment/vendor/list').then(res => {
            let makeResult = apiResponse(res, []);
            if (makeResult.isUnauthorized) {
                dispatch(toastError(makeResult.message));
                dispatch(tokenExpired());
            } else if (makeResult.data) {
                dispatch(equipmentVendorList(makeResult.data));
            } else if (makeResult.message) {
                dispatch(toastError(makeResult.message));
                dispatch(equipmentVendorList(null));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(equipmentVendorList(null));
        });
    }
}

export const deleteEquipment = (data) => {
    return dispatch => {
        defaultAgent.put('/api/equipment/v1/delete', { farm_uuid: data.farm_uuid, equipment_uuid: data.equipment_uuid })
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === EQUIPMENT_DELETED.code) {
                    dispatch(toastInfo(agentResult.message));
                    dispatch(getEquipmentList({ farmId: data.farm_uuid }));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const getEquipmentInfo = (data) => {
    return dispatch => {
        defaultAgent.get('/api/equipment/v1/info', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.data) {
                    dispatch(equipmentInfo(agentResult.data));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(equipmentInfo());
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(equipmentInfo());
            });
    }
}